
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","preserveAspectRatio":"xMidYMid meet"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#003653","fill-rule":"evenodd","d":"M14.334 4L7.11 12.156a.436.436 0 00.053.627.465.465 0 00.297.106h3.208V20l7.224-8.156a.436.436 0 00-.053-.627.464.464 0 00-.295-.106h-3.209V4z"}})])
          )
        }
      }
    